"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/VideoCall/Modals/Settings.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _lodash = require('lodash');

var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);
var _Modal = require('web/components/Modal'); var _Modal2 = _interopRequireDefault(_Modal);
var _ui = require('web/services/ui');
var _AudioSetupGroup = require('web/screens/VideoCall/segments/AudioSetupGroup'); var _AudioSetupGroup2 = _interopRequireDefault(_AudioSetupGroup);
var _VideoSetupGroup = require('web/screens/VideoCall/segments/VideoSetupGroup'); var _VideoSetupGroup2 = _interopRequireDefault(_VideoSetupGroup);

const mobileTabs = {
  AUDIO: 'MOBILE_SETTINGS_AUDIO_TAB',
  VIDEO: 'MOBILE_SETTINGS_VIDEO_TAB',
} 









const SettingsModal = ({ isOpen, onClose, onUserProblemPublish }) => {
  const [activeMobileTab, setActiveMobileTab] = _react.useState(mobileTabs.VIDEO)
  const [isMobileActive, setIsMobileActive] = _react.useState.call(void 0, _ui.isMobileScreen)

  const setVideoTabActive = _react.useCallback.call(void 0, () => setActiveMobileTab(mobileTabs.VIDEO), [])
  const setAudioTabActive = _react.useCallback.call(void 0, () => setActiveMobileTab(mobileTabs.AUDIO), [])

  // One throttled listener per mounted modal, like the class field.
  const [watchResize] = _react.useState.call(void 0, () => _lodash.throttle.call(void 0, 
    () => setIsMobileActive(_ui.isMobileScreen.call(void 0, ))
    , 100,
  ))

  // componentDidMount / componentWillUnmount
  _react.useLayoutEffect.call(void 0, () => {
    window.addEventListener('resize', watchResize)
    return () => window.removeEventListener('resize', watchResize)
  }, [watchResize])

  const renderMobileScreen = () => {
    const isAudioTabActive = activeMobileTab === mobileTabs.AUDIO
    const isVideoTabActive = activeMobileTab === mobileTabs.VIDEO

    const buildTabToggleClassName = (active) =>
      _classBuilder2.default.call(void 0, "meeting--settings-mobile--tab-toggle", { active })
    const videoTabToggleClassName = buildTabToggleClassName(isVideoTabActive)
    const audioTabToggleClassName = buildTabToggleClassName(isAudioTabActive)

    return (
      _react2.default.createElement('div', { className: "meeting--settings-modal--mobile", __self: this, __source: {fileName: _jsxFileName, lineNumber: 52}}
        , _react2.default.createElement('div', { className: "meeting--settings-modal--body", __self: this, __source: {fileName: _jsxFileName, lineNumber: 53}}
          , _react2.default.createElement('div', { className: "meeting--settings-mobile--content", __self: this, __source: {fileName: _jsxFileName, lineNumber: 54}}
            , _react2.default.createElement('div', { className: "meeting--settings-mobile--tabbar", __self: this, __source: {fileName: _jsxFileName, lineNumber: 55}}
              , _react2.default.createElement('div', {
                onClick: setVideoTabActive,
                className: videoTabToggleClassName, __self: this, __source: {fileName: _jsxFileName, lineNumber: 56}}

                , _react2.default.createElement('img', {
                  alt: "video",
                  src: isVideoTabActive
                    ? '/assets/icons/video/camera-purple.svg'
                    : '/assets/icons/video/camera-grey.svg'
                  , __self: this, __source: {fileName: _jsxFileName, lineNumber: 60}}
                )
                , _react2.default.createElement('span', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 67}}, "Video")
              )
              , _react2.default.createElement('div', {
                onClick: setAudioTabActive,
                className: audioTabToggleClassName, __self: this, __source: {fileName: _jsxFileName, lineNumber: 69}}

                , _react2.default.createElement('img', {
                  alt: "audio",
                  src: isAudioTabActive
                    ? '/assets/icons/video/loudspeaker-purple.svg'
                    : '/assets/icons/video/loudspeaker-grey.svg'
                  , __self: this, __source: {fileName: _jsxFileName, lineNumber: 73}}
                )
                , _react2.default.createElement('span', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 80}}, "Audio")
              )
            )
            , _react2.default.createElement('div', { className: "meeting--settings-mobile--content--wrapper", __self: this, __source: {fileName: _jsxFileName, lineNumber: 83}}
              ,  isVideoTabActive
                ? _react2.default.createElement(_VideoSetupGroup2.default, { onUserProblemPublish: onUserProblemPublish, __self: this, __source: {fileName: _jsxFileName, lineNumber: 85}} )
                : _react2.default.createElement(_AudioSetupGroup2.default, { onUserProblemPublish: onUserProblemPublish, __self: this, __source: {fileName: _jsxFileName, lineNumber: 86}} )
              
            )
          )
          , _react2.default.createElement('a', {
            onClick: onClose,
            className: "blmh-button meeting--btn primary purple highlight meeting--settings-mobile--proceed"     , __self: this, __source: {fileName: _jsxFileName, lineNumber: 90}}
, "OK"

          )
        )
      )
    )
  }

  const renderDesktopScreen = () => (
    _react2.default.createElement('div', { className: "meeting--settings-modal--desktop", __self: this, __source: {fileName: _jsxFileName, lineNumber: 102}}
      , _react2.default.createElement('div', { className: "meeting--settings-modal--body", __self: this, __source: {fileName: _jsxFileName, lineNumber: 103}}
        , _react2.default.createElement('div', { className: "meeting--settings-desktop--grid", __self: this, __source: {fileName: _jsxFileName, lineNumber: 104}}
          , _react2.default.createElement(_VideoSetupGroup2.default, { onUserProblemPublish: onUserProblemPublish, __self: this, __source: {fileName: _jsxFileName, lineNumber: 105}} )
          , _react2.default.createElement(_AudioSetupGroup2.default, { onUserProblemPublish: onUserProblemPublish, __self: this, __source: {fileName: _jsxFileName, lineNumber: 106}} )
        )
        , _react2.default.createElement('a', {
          onClick: onClose,
          className: "blmh-button meeting--btn primary purple highlight meeting--settings-desktop--proceed"     , __self: this, __source: {fileName: _jsxFileName, lineNumber: 108}}
, "Done"

        )
      )
    )
  )

  return (
    _react2.default.createElement(_Modal2.default, {
      isOpen: isOpen,
      onClose: onClose,
      className: "meeting--settings-modal",
      title: "Settings", __self: this, __source: {fileName: _jsxFileName, lineNumber: 119}}

      ,  isMobileActive
        ? renderMobileScreen()
        : renderDesktopScreen()
      
    )
  )
}

exports. default = SettingsModal
